import React, { useEffect, useState } from 'react';
import IdentitiesList from './IdentitiesList';
import API from '../../api-graphql';

const Bioadmin = () => {
  const [identities, setIdentities] = useState([]);

  const getIdentities = async () => {
    await API.listUsersForBioadmin().then(data => {
      setIdentities(data.data.listUsers.items);
    }).catch(error => {
      console.log(error);
    });
  };

  useEffect(() => {
    getIdentities();
  }, []);

  return <IdentitiesList identities={identities} />;
};
export default Bioadmin;
